import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=50e1a37a&scoped=true"
import script from "./BankAccountList.vue?vue&type=script&lang=js"
export * from "./BankAccountList.vue?vue&type=script&lang=js"
import style0 from "./BankAccountList.vue?vue&type=style&index=0&id=50e1a37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1a37a",
  null
  
)

export default component.exports